import { combineReducers } from "redux"
import { queryresolved } from './queryResolvedReducer'

const queryResolvedReducers = combineReducers({
    queryresolved,
})

export default queryResolvedReducers